import { createContext } from "react";

const ProductLicenseFormContext = createContext({
  /**
   * Form state from useProductLicensingFormState
   */
  formState: {},
  /**
   * The current license deployment status object
   */
  licenseDeployment: null,
  /**
   * Whether the deployment status is loading
   */
  isDeploymentFetching: false,
  /**
   * Refetch the deployment status
   */
  refetchDeploymentStatus: () => {},
  /**
   * Mutation for retrying a license deployment
   */
  licenseDeployRetryMutation: {},
  /**
   * Mutation for submitting product license changes
   */
  productLicenseMutation: {},
  /**
   * Customer segment data: { segment, medicareLicensed, isPrOrg, prNumber }
   */
  customerSegment: {},
  /**
   * Customer segment display name
   */
  customerSegmentName: "",
  /**
   * Product licenses data from the organization
   */
  productLicenses: {},
  /**
   * Whether product licenses are loading
   */
  isLoadingLicenses: false,
  /**
   * Refetch product licenses
   */
  refetchProductLicenses: () => {},
  /**
   * Whether product licenses are refetching
   */
  isRefetchingProductLicenses: false,
});

export default ProductLicenseFormContext;
